import VueFroala from 'vue-froala-wysiwyg';
import '@src/css/vendor/froala_plugins.pkgd.css';
import '@src/css/vendor/froala_editor.pkgd.css';
import 'froala-editor/js/plugins.pkgd.min.js';

export default ({Vue}) => {

  Vue.use(VueFroala);
};
